<!--
 * @Author: AnNa
 * @Date: 2021-08-09 11:27:02
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-13 10:09:46
 * @Description:
-->
<template>
  <page-view>
    <a-icon
      slot="icon"
      @click="$router.back(-1)"
      style="font-size: 18px; margin-top: 4px; margin-right: 5px"
      type="arrow-left"
    ></a-icon>
    <a-card :bordered="false">
      <a-row>
        <a-col :span="16">
          <a-form
            :form="form"
            @submit="handleSubmit"
            style="max-width: 700px; margin: 0px 100px"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a
              style="
                color: blue;
                text-decoration: underline;
                font-size: 16px;
                margin-left: 5%;"
              href="https://www.yuque.com/docs/share/521c8c25-78ba-44ff-b098-a2bbd46b3bbd?#">点击跳转：2022年淘宝双十一超级红包宣传素材</a>
            <a-divider :dashed="true" orientation="left">商品信息</a-divider>
            <!-- <a-form-item
              label="自定义发圈名称">
              <a-input placeholder="请输入任务名称，方便查询任务列表" v-decorator="['trend_name', {rules: [{required: true, message: '必填项'}]}]"></a-input>
            </a-form-item> -->
            <a-alert v-if="alertFlag" type="warning" :style="{ padding: '5px', width: '450px', marginLeft: '33%' }"
              description="尊敬的用户，由于淘宝联盟要求，数字id不再支持解析，请输入新的非数字类型的商品id！"/>
            <a-form-item v-show="JSON.stringify(params) === '{}'" label="商品ID">
              <a-input
                style="position: relative;"
                placeholder="请输入商品ID"
                v-decorator="[
                  'goods_id',
                  { initialValue: params.goodsId, rules: [{ required: false, message: '必填项' }] },
                ]"
              ></a-input>
              <a-button @click="getGoods(false)" type="primary" :loading="infoLoading"> 解析ID </a-button>
            </a-form-item>
            <a-form-item v-show="JSON.stringify(params) === '{}'" label="商品来源">
              <a-radio-group v-decorator="['goods_type', { initialValue: 'tb' }]">
                <a-radio-button value="tb"> 淘宝 </a-radio-button>
                <!-- <a-radio-button value="jd"> 京东 </a-radio-button>
                <a-radio-button value="pdd"> 拼多多 </a-radio-button> -->
              </a-radio-group>
            </a-form-item>
            <a-form-item label="发圈类型">
              <a-radio-group @change="e => (type = e.target.value)" v-decorator="['trend_type', { initialValue: 1 }]">
                <a-radio-button :value="1"> 图文 </a-radio-button>
                <a-radio-button :value="2"> 文本 </a-radio-button>
                <!-- <a-radio-button :value="3"> 视频 </a-radio-button> -->
              </a-radio-group>
            </a-form-item>
            <a-divider :dashed="true" orientation="left">发圈内容</a-divider>
            <a-form-item label="文案">
              <a-textarea :style="width" :autoSize="{ minRows: 3 }" v-decorator="['trend_text']">
                <a-icon slot="addonAfter" type="setting" />
              </a-textarea>
            </a-form-item>
            <a-form-item v-show="type === 1" label="图片">
              <div class="clearfix">
                <a-upload
                  accept=".jpg, .jpeg, .png"
                  list-type="picture-card"
                  :file-list="imgList"
                  @preview="handlePreview"
                  @change="handleImgChange"
                  :customRequest="uploadImg"
                >
                  <div v-if="imgList.length < 9">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传图片</div>
                  </div>
                </a-upload>
              </div>
            </a-form-item>
            <a-form-item v-show="type === 3" label="视频封面">
              <div class="clearfix">
                <a-upload
                  accept=".jpg, .jpeg, .png"
                  list-type="picture-card"
                  :file-list="videoImgList"
                  @preview="handlePreview"
                  @change="handleVideoImgChange"
                  :customRequest="uploadVideoImg"
                >
                  <div v-if="videoImgList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传图片</div>
                  </div>
                </a-upload>
              </div>
            </a-form-item>
            <a-form-item v-show="type === 3" label="视频">
              <div class="clearfix">
                <a-upload
                  accept=".mp4, .avi, .flv"
                  list-type="picture"
                  :file-list="videoList"
                  @preview="handleVideoPreview"
                  @change="handleVideoChange"
                  :customRequest="uploadVideo"
                >
                  <a-button v-if="videoList.length < 1"> <a-icon type="upload" /> 上传视频 </a-button>
                </a-upload>
              </div>
            </a-form-item>
            <a-divider :dashed="true" orientation="left">评论留言</a-divider>
            <a-form-item label="评论">
              <a-input-group>
                <div v-for="(item, index) in messageList" :key="index" :style="{ marginBottom: '10px' }">
                  <a-row :gutter="20">
                    <a-col :span="16">
                      <a-textarea
                        :style="width"
                        :rows="{ minRows: 2, maxRows: 4 }"
                        style="margin-bottom: 10px"
                        placeholder="评论信息"
                        v-model="messageList[index]"
                      ></a-textarea>
                      <span v-for="(item, index) in nods" :key="index">
                        <a-tag @click="copy(item)">{{ item }}</a-tag>
                      </span>
                    </a-col>
                    <a-col :span="8">
                      <a-popconfirm ok-text="确定" cancel-text="取消" @confirm="messageList.splice(index, 1)">
                        <a-button
                          icon="close"
                          size="small"
                          type="danger"
                          :style="{ marginRight: '5px' }"
                          shape="circle"
                        >
                        </a-button>
                        <template slot="title"> 删除评论吗？ </template>
                      </a-popconfirm>
                      <emoji-dialog @cencel="copyEmoji" />
                      <message-dialog :style="{ marginLeft: '5px' }" @append="handleAppendMsg" />
                    </a-col>
                  </a-row>
                </div>
              </a-input-group>
              <a-button
                :style="width"
                :disabled="messageList.length >= 4"
                type="dashed"
                @click="messageList.push('')"
                block
              >
                {{ 4 - messageList.length }}条评论可添加
              </a-button>
            </a-form-item>
            <a-form-item label="发送时间">
              <a-radio-group
                @change="e => (sendType = e.target.value)"
                v-decorator="['sendTimeType', { initialValue: 1 }]"
              >
                <a-radio :value="1"> 立即发送 </a-radio>
                <a-radio :value="2"> 定时发送 </a-radio>
              </a-radio-group>
              <br />
              <a-date-picker
                v-model="sendTime"
                format="YYYY-MM-DD HH:mm:ss"
                v-show="sendType === 2"
                show-time
                placeholder="选择发送时间"
              />
            </a-form-item>
            <a-form-item label="推送到">
              <robot-multiple
                v-decorator="['robotids', { rules: [{ required: true, message: '必填项' }] }]"
              ></robot-multiple>
            </a-form-item>
            <!-- <a-form-item :wrapper-col="{ xs: { span: 12, offset: 0 }, sm: { span: 12, offset: 4 } }">
              <a-button htmlType="submit" type="primary">推送</a-button>
            </a-form-item> -->
            <div style="text-align: center">
              <a-button type="primary" @click="handleSubmit">推送设置</a-button>
            </div>
          </a-form>
        </a-col>
        <a-col :span="8">
          <mobile-model
            :info="{
              imgs: imgList,
              video: videoList,
              message: messageList,
              text: form.getFieldValue('trend_text'),
              type: form.getFieldValue('trend_type'),
            }"
          />
        </a-col>
      </a-row>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="img" style="width: 100%" :src="previewImage" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoVisible = false">
        <video controls style="width: 100%" :src="previewVideo" />
      </a-modal>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import PageHeader from 'ant-design-vue/es/page-header'
import Comment from 'ant-design-vue/es/comment'
import { TreeSelect } from 'ant-design-vue'
import { readFileAsBuffer, upload } from '@/utils/oss'
import EmojiDialog from './components/EmojiDialog'
import RobotMultiple from '@/views/components/RobotMultiple'
import MessageDialog from './modules/MessageDialog'
import MobileModel from './modules/MobileModel'
import { queryGoodInfo, PushTaskOfPyq } from '@/api/pyq'
import moment from 'moment'
import { mapActions } from 'vuex'
const nods = ['[淘口令]', '[京东短链接]', '[拼多多短链接]', '[原价]', '[券后价]', '[券面值]', '[商品标题]', '[中间页]']
function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export default {
  data () {
    return {
      loading: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 8 }, sm: { span: 8 } },
      wrapperCol: { lg: { span: 16 }, sm: { span: 16 } },
      nods,
      infoLoading: false,
      previewVisible: false,
      previewVideoVisible: false,
      previewImage: '',
      userTree: [],
      previewVideo: '',
      messageList: [''],
      imgList: [],
      videoList: [],
      videoImgList: [],
      type: 1,
      sendType: 1,
      sendTime: null,
      width: {
        width: '300px'
      },
      treeData: [],
      alertFlag: false,
      // SHOW_PARENT,
    }
  },
  computed: {
    params () {
      // console.log(this.$route.params, 'computed')
      return this.$route.params || {}
    }
  },
  watch: {
    params: {
      deep: true,
      handler (n) {
        // console.log(n, 'watch')
        if (JSON.stringify(n) !== '{}') {
          this.form.setFieldsValue({
            goods_id: n.goodsId
          })
          this.getGoods(true)
        }
      }
    }
  },
  components: {
    PageView,
    PageHeader,
    TreeSelect,
    EmojiDialog,
    MessageDialog,
    MobileModel,
    Comment,
    RobotMultiple
  },
  mounted () {
    const params = this.$route.params
    if (JSON.stringify(params) !== '{}') {
      this.getGoods(true)
    }
  },

  methods: {
    moment,
    ...mapActions(['BatchpushTask', 'TaskDrawerSwitch']),
    copy (text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    onSelect (selectedKeys, info) {
      // console.log('selected', selectedKeys, info)
    },
    onCheck (checkedKeys, info) {
      // console.log('onCheck', checkedKeys, info)
    },
    handleAppendMsg (text) {
      if (this.messageList.length >= 4) {
        this.$message.error('评论最大可添加4个！')
      } else {
        this.messageList.push(text)
      }
    },
    getGoods (type) {
      this.alertFlag = false
      // this.form.validateFields((err, values) => {
      const goods_id = this.form.getFieldValue('goods_id')
      const goods_type = this.form.getFieldValue('goods_type')
      this.infoLoading = true
      // console.log(this.params, 'goods')
      queryGoodInfo({
        goods_id: type ? this.params.goodsId : goods_id,
        goods_type: type ? 'tb' : goods_type
      })
        .then(res => {
          this.$message.success('解析完成')
          if (res.code != 1) {
            this.alertFlag = true
            this.$message.error(res.msg)
            return false
          }
          if (res.data.shipai_pic.length !== 0 && res.data.shipai_pic !== '[]') {
            this.form.setFieldsValue({
              trend_text: res.data.circle_text
            })
            this.imgList = []
            const shipai = res.data.shipai_pic.slice(1, res.data.shipai_pic.length - 1)
            // console.log(shipai.split(','))

            shipai.split(',').forEach((v, i) => {
              this.imgList.push({
                uid: i - 1,
                name: `${1}.jpg`,
                status: 'done',
                url: `${v}`
              })
            })
          }
        })
        .finally(() => {
          this.infoLoading = false
        })
      // })
    },
    handleCancel () {
      this.previewVisible = false
    },

    copyEmoji (emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    pushMessage () {
      if (this.message === '') {
        this.$message.error('请输入评论内容')
        return null
      }
      this.messageList.push(this.message)
      this.message = ''
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    async handleVideoPreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewVideo = file.url || file.preview
      this.previewVideoVisible = true
    },
    handleImgChange ({ fileList }) {
      this.imgList = fileList
    },
    handleVideoImgChange ({ fileList }) {
      this.videoImgList = fileList
    },
    handleVideoChange ({ fileList }) {
      this.videoList = fileList
    },
    uploadImg (file) {
      // console.log(file)
      readFileAsBuffer(file.file)
        .then(builderFile => {
          upload(builderFile, file.file, 'friend-images')
            .then(res => {
              file.onSuccess({
                name: res.data.name,
                status: 'done',
                thumbUrl: res.url,
                url: res.url
              })
            })
            .catch(err => {
              file.onError(err)
            })
        })
        .catch(err => {
          file.onError(err)
        })
    },
    uploadVideoImg (file) {
      readFileAsBuffer(file.file)
        .then(builderFile => {
          upload(builderFile, file.file, 'videoImg')
            .then(res => {
              file.onSuccess({
                name: res.data.name,
                status: 'done',
                thumbUrl: res.url,
                url: res.url
              })
            })
            .catch(err => {
              file.onError(err)
            })
        })
        .catch(err => {
          file.onError(err)
        })
    },
    uploadVideo (file) {
      let fileSize = file.file.size
      fileSize = Math.round(fileSize / 1024 / 1024) // 单位为KB
      if (fileSize >= 10) {
        setTimeout(() => {
          file.onError('视频最大为10MB')
          alert('视频最大尺寸为10MB，请重新上传!')
        }, 300)
      } else {
        readFileAsBuffer(file.file)
          .then(builderFile => {
            upload(builderFile, file.file, 'video')
              .then(res => {
                // console.log(res)
                file.onSuccess({
                  name: res.data.name,
                  status: 'done',
                  thumbUrl: res.url,
                  url: res.url
                })
              })
              .catch(err => {
                file.onError(err)
              })
          })
          .catch(err => {
            file.onError(err)
          })
      }
    },
    getConfig () {
      // GetSendConfig().then(res => {
      //   const cfg = res.data
      //   this.form.setFieldsValue({
      //     whether_billing_group: cfg.whether_billing_group === 1,
      //     whether_billing_circle: cfg.whether_billing_circle === 1,
      //     whether_turn_url: cfg.whether_turn_url === 1,
      //     group_wait_time: cfg.billing_group_config.group_wait_time,
      //     msg_wait_time: cfg.billing_group_config.msg_wait_time,
      //     tb_message_template: cfg.billing_group_config.tb_message_template,
      //     jd_message_template: cfg.billing_group_config.jd_message_template,
      //     pdd_message_template: cfg.billing_group_config.pdd_message_template
      //   })
      // })
    },
    replace (str) {
      if (str.indexOf('\\ue') !== -1) {
        // eslint-disable-next-line no-eval
        var a = str.substr(str.indexOf('\\ue'), 6)
        str = str.replace(a, eval("'" + a + "'"))
        return this.replace(str)
      } else {
        return str
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const imgs = []
          if (this.imgList.length > 0) {
            this.imgList.forEach((v, i) => {
              if (v.url) {
                imgs.push(v.url)
              } else {
                imgs.push(v.response.url)
              }
            })
            // console.log(imgs)
          }
          this.loading = true
          const mess = []
          if (this.messageList.length > 0) {
            this.messageList.forEach((v, i) => {
              mess.push(this.replace(v))
            })
          }
          this.BatchpushTask({
            robotids: values.robotids,

            descs: '朋友圈推送',
            apiFun: sub_id => {
              return PushTaskOfPyq({
                trend_name: values.trend_name,
                sub_id: sub_id,
                image_url: imgs,
                tend_comment: mess,
                trend_text: values.trend_text ? this.replace(values.trend_text) : '',
                video_url: this.videoList.length > 0 ? this.videoList[0].response.url : '',
                video_image_url: this.videoImgList.length > 0 ? this.videoImgList[0].response.url : '',
                trend_type: values.trend_type,
                goods_id: values.goods_id,
                goods_type: values.goods_type,
                send_time: values.sendTimeType === 1 ? '' : this.sendTime.format('YYYY-MM-DD HH:mm:ss')
              })
            }
          })
          this.TaskDrawerSwitch({ status: true })
          this.form.resetFields('robotids')

          // console.log(this.userTree)
          // SaveSendConfig(values).then(() => {
          //   this.$message.success('保存成功')
          // }).finally(() => {
          //   this.loading = false
          // })
        } else {
          // console.log(err)
        }
      })
    }
  }
}
</script>
